import { ChainId } from '@sushiswap/chain'
import { FURO_SUBGRAPH_URL } from '@sushiswap/graph-config'
import { useQuery } from '@tanstack/react-query'

import { getBuiltGraphSDK } from '../../.graphclient'
import { isSupportedChainId } from '../../config'
import { Stream } from '../Stream'
import { fetchWithTimeout } from './fetchWithTimeout'
import { queryRebaseDTO } from './useRebaseDTO'

interface UseStream {
  chainId: ChainId
  streamId: string
  enabled?: boolean
}

export const useStream = ({ chainId, streamId, enabled = true }: UseStream) => {
  return useQuery({
    queryKey: ['useStream', { chainId, streamId }],
    queryFn: async () => {
      if (!isSupportedChainId(chainId)) return null

      const sdk = getBuiltGraphSDK({
        chainId,
        url: FURO_SUBGRAPH_URL[chainId]
      })

      const data = await fetchWithTimeout(() => sdk.stream({ id: streamId }))
      const token = data?.stream?.token.id
      const rebase = await fetchWithTimeout(() => queryRebaseDTO({ chainId, address: token }))

      return data.stream && rebase ? new Stream({ chainId, furo: data.stream, rebase }) : null
    },
    refetchInterval: 60000,
    enabled,
  })
}
